module.exports = __webpack_public_path__ + "img/singapore_sling.cc672bbf.jpg";